

import React from 'react';
import './LandBg.css';
import styled from 'styled-components';
import logo from '../../assets/logo-transparent.png';

const Brand = styled.img`
  display:flex;
  opacity: 20%;
  width: 60%;
  justify-content: left;
  margin-left:50px;
  margin-top: 30px;
  margin-left: 200px;
  @media (max-width: 768px) {
    display:none;
  }
`;

const LandBg = props => (

	<div className= "landbg" >
	     
          <Brand src={logo}/>          
          
	     
	</div>
	);

export default LandBg;